import {
  httpServer
} from "../../api/index";
import * as pbFunc from "../utils";
/**
 * @function stationTypePath
 * @memberOf pbFunc
 * @ngdoc function
 * @description 设备详情根据设备类型不同选择路由
 * @param  {String} type [设备类型]
 * @param  {string}  stationId [自动站id]
 * @param  {string}  id [设备id]
 * @return {String}     [返回路由]
 */
export const stationTypePath = function (type, stationId, id) {
  switch (type) {
    default:
      return `/automaticStation/classifySystem/` + type + `/` + stationId + `/` + id;
      break;
  }
}
/**
 * @function statisticsTypePath
 * @memberOf pbFunc
 * @ngdoc function
 * @description 统计页面根据设备数据类型不同选择路由
 * @param  {String} type [设备类型]
 * @param  {string}  stationId [自动站id]
 * @param  {string}  id [设备数据类型id]
 * @param  {string}  name [设备数据类型]
 * @return {String}     [返回路由]
 */
export const statisticsTypePath = function (type, stationId, id, name) {
  if (name) {
    return `/dataStatistics/systemData/` + type + `/` + stationId + `/` + id + '/' + name;
  } else {
    if (type === 'HpgeData') {
      return `/dataStatistics/nuclideIdentification/` + type + `/` + stationId;
    } else {
      return `/dataStatistics/dataAcquisition/` + type + `/` + stationId;
    }

  }

}
/**
 * @function isMovable
 * @memberOf pbFunc
 * @ngdoc function
 * @description 是否为移动设备
 * @param  {Boolean}  type [是否为移动设备 true/false]
 * @return {String}      [返回设备中文]
 */
export const isMovable = function (type) {
  return type ? '移动设备' : '固定设备'
}

/**
 * @function deviceState
 * @memberOf pbFunc
 * @ngdoc function
 * @description   设备状态
 * @param  {String}  status [设备状态 online/offline/unknown]
 * @return {String}      [返回状态中文]
 */
export const deviceState = function (status) {
  switch (status) {
    case "online":
      return {
        className: 'font-color-success',
          name: '在线'
      };
      break;
    case "offline":
      return {
        className: 'font-color-no',
          name: '离线'
      };
      break;
    case "unknown":
      return {
        className: 'font-color-alarm',
          name: '未知'
      };
      break;
      case "alert":
      return {
        className: 'font-color-red',
        name: '报警'
      };
      break;
      
  }
}
/**
 * @function alarmTypeName
 * @memberOf pbFunc
 * @ngdoc function
 * @description   报警消息类别
 * @param  {String}  status [报警消息类别 123456]
 * @return {String}      [返回状态中文]
 */
export const alarmTypeName = function (status) {
  switch (status) {
    case 1:
      return {
        className: 'font-color-no',
          name: '设备离线'
      };
      break;
    case 2:
      return {
        className: 'font-color-red',
          name: '高高报警'
      };
      break;
    case 3:
      return {
        className: 'font-color-alarm',
          name: '高报警'
      };
      break;
    case 4:
      return {
        className: 'font-color-success',
          name: '设备离线恢复'
      };
      break;
    case 5:
      return {
        className: 'font-color-success',
          name: '高高报警恢复'
      };
      break;
    case 6:
      return {
        className: 'font-color-success',
          name: '高报警恢复'
      };
      break;
  }
}
//设备echart图表展示/下载
export const echartsData = function (id, type, startTime, endTime, field, time, isDown, isBar) {
  let postData = {
    device: id,
    device_data_model: type,
    start_time: startTime ? startTime : "",
    end_time: endTime ? endTime : "",
    field: field ? field : "",
    time_interval: time ? time : ''
  }
  if (isBar) {
    postData.chart_type = 'bar';
  }
  return new Promise((resolve, reject) => {
    httpServer(isDown ? 'echartsDataDownCsv' : "echartsData", postData)
      .then(results => {
        if (results.data && results.status == 200) {
          resolve(results.data);
        } else {
          reject(null);
        }
      })
      .catch(err => {});
  });
}


export const deviceName = function (deviceId, type) {
  console.log('type', deviceId, type)
  let statisticsList = pbFunc.getLocalData("statistics", true);
  for (let i in statisticsList) {
    if (statisticsList[i].id == deviceId && statisticsList[i].device_type_code == type) {
      return statisticsList[i].name;
    }
    if (statisticsList[i].device_type_code == 'AGS421') {
      for (let j in statisticsList[i].field_menu) {
        if (statisticsList[i].field_menu[j].id == deviceId) {
          return statisticsList[i].field_menu[j].title;
        }
      }
    }

  }
}


export const stationList = function (id) {
  return new Promise((resolve, reject) => {
    httpServer('stationList', {
        id: id,
      })
      .then(results => {
        if (results.data && results.status == 200) {
          resolve(results.data);
        } else {
          reject(null);
        }
      })
      .catch(err => {});
  });
}



// WEBPACK FOOTER //
// ./src/assets/js/business.js